import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { BillingFilterComponent } from '../../billing-filter/billing-filter.component';
import { BillingService } from '../../../../services/billing.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-ignored-timesheets-data',
  standalone: true,
  imports: [CommonModule, ListTableComponent, BillingFilterComponent],
  templateUrl: './ignored-timesheets-data.component.html',
  styleUrl: './ignored-timesheets-data.component.css',
})
export class IgnoredTimesheetsDataComponent implements OnInit {
  @Input() ignoredTimesheetData: any;
  @Input() selectedBatchId: any;

  appliedFilters: any;
  programName!: string;

  fields = [
    { field: 'timesheetId', show: true },
    { field: 'participantPplId', show: true },
    { field: 'providerPplId', show: true }
  ];

  cols = [
    {
      field: 'timesheetId',
      header: 'Timesheet ID',
      jsonpath: 'timesheetId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'consumerName',
      header: 'Consumer Name',
      jsonpath: 'consumerName',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'participantPplId',
      header: 'Consumer PPL ID',
      jsonpath: 'participantPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'providerPplId',
      header: 'PA PPL ID',
      jsonpath: 'providerPplId',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceCode',
      header: 'Service Code',
      jsonpath: 'serviceCode',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'serviceDuration',
      header: 'Service Duration',
      jsonpath: 'serviceDuration',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'paidUnits',
      header: 'Units',
      jsonpath: 'paidUnits',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'ignoreReason',
      header: 'Reason',
      jsonpath: 'ignoreReason',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];

  constructor(
    private billingService: BillingService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
  }

  onPageLoad(event: any) {
    this.searchTimesheets(
      this.appliedFilters,
      event.startingPageNumber,
      event?.first ?? 0
    );
  }

  onSearch(filters: any) {
    this.appliedFilters = filters;
    this.searchTimesheets(filters);
  }

  searchTimesheets(filters: any, startingPageNumber = 1, currentPage = 0) {
    if (startingPageNumber == 1) {
      this.ignoredTimesheetData = [];
    }
    console.log('filters here', filters);
    this.ignoredTimesheetData = [];
    const payload = this.buildPayload(filters);
    this.billingService.searchIgnoredTimesheets(payload)
    .subscribe((data: any) => {
      this.ignoredTimesheetData = data.responsedata;
    });
  }

  buildPayload(filters: any) {
    const payload: any = {
      timesheetId: '',
      providerPplId: '',
      participantPplId: '',
      programCode: this.programName,
      billingBatchMaster: this.selectedBatchId
    };

    if (filters && filters.length > 0) {
      filters.forEach((filter: any) => {
        switch (filter.jsonPath) {
          case 'timesheetId':
            payload.timesheetId = filter.value;
            break;
          case 'providerPplId':
            payload.providerPplId = filter.value;
            break;
          case 'participantPplId':
            payload.participantPplId = filter.value;
            break;
        }
      });
    }

    console.log('Payload:', payload);
    return payload;
  }
}
